import { render, staticRenderFns } from "./OtpView.vue?vue&type=template&id=273d0efd&scoped=true&"
import script from "./OtpView.vue?vue&type=script&lang=js&"
export * from "./OtpView.vue?vue&type=script&lang=js&"
import style0 from "./OtpView.vue?vue&type=style&index=0&id=273d0efd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d0efd",
  null
  
)

export default component.exports